import { render, staticRenderFns } from "./GuOrganDetail.vue?vue&type=template&id=255f3dc4&scoped=true&"
import script from "./GuOrganDetail.vue?vue&type=script&lang=js&"
export * from "./GuOrganDetail.vue?vue&type=script&lang=js&"
import style0 from "./GuOrganDetail.vue?vue&type=style&index=0&id=255f3dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255f3dc4",
  null
  
)

export default component.exports